function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.16411,
    y: 0.910448,
    width: 37.4328,
    height: 24.1791,
    rx: 4.38806,
    fill: "#FFEFE5",
    style: {
      fill: "#FFEFE5",
      fill: "color(display-p3 1.0000 0.9373 0.8980)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.16411,
    y: 0.910448,
    width: 37.4328,
    height: 24.1791,
    rx: 4.38806,
    stroke: "#D6DCE5",
    style: {
      stroke: "#D6DCE5",
      stroke: "color(display-p3 0.8392 0.8627 0.8980)",
      strokeOpacity: 1
    },
    strokeWidth: 0.179104
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5567 8.2504H16.0716V18.1072H21.5567V8.2504Z",
    fill: "#FF5F00",
    style: {
      fill: "#FF5F00",
      fill: "color(display-p3 1.0000 0.3725 0.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4199 13.1788C16.419 12.2295 16.6341 11.2925 17.0489 10.4386C17.4637 9.58477 18.0674 8.83648 18.8141 8.2504C17.8894 7.52352 16.7788 7.07148 15.6093 6.94596C14.4397 6.82043 13.2585 7.02648 12.2006 7.54055C11.1426 8.05463 10.2506 8.85599 9.6266 9.85303C9.00256 10.8501 8.67163 12.0026 8.67163 13.1788C8.67163 14.355 9.00256 15.5075 9.6266 16.5046C10.2506 17.5016 11.1426 18.303 12.2006 18.8171C13.2585 19.3311 14.4397 19.5372 15.6093 19.4117C16.7788 19.2861 17.8894 18.8341 18.8141 18.1072C18.0674 17.5211 17.4638 16.7728 17.0489 15.919C16.6341 15.0651 16.419 14.1281 16.4199 13.1788Z",
    fill: "#EB001B",
    style: {
      fill: "#EB001B",
      fill: "color(display-p3 0.9216 0.0000 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9563 13.1788C28.9564 14.355 28.6255 15.5075 28.0015 16.5046C27.3775 17.5016 26.4855 18.303 25.4276 18.8171C24.3697 19.3311 23.1885 19.5372 22.019 19.4117C20.8495 19.2861 19.7389 18.8341 18.8141 18.1072C19.5602 17.5206 20.1634 16.7721 20.5781 15.9184C20.9929 15.0647 21.2084 14.1279 21.2084 13.1788C21.2084 12.2297 20.9929 11.2929 20.5781 10.4392C20.1634 9.58548 19.5602 8.83707 18.8141 8.2504C19.7389 7.52352 20.8495 7.07148 22.019 6.94596C23.1885 6.82043 24.3697 7.02649 25.4276 7.54057C26.4855 8.05465 27.3775 8.85601 28.0015 9.85305C28.6255 10.8501 28.9564 12.0026 28.9563 13.1788Z",
    fill: "#F79E1B",
    style: {
      fill: "#F79E1B",
      fill: "color(display-p3 0.9686 0.6196 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3583 17.0632V16.8614H28.4396V16.8203H28.2324V16.8614H28.3138V17.0632H28.3583ZM28.7606 17.0632V16.8199H28.6971L28.624 16.9873L28.5509 16.8199H28.4874V17.0632H28.5322V16.8797L28.6007 17.0379H28.6473L28.7158 16.8793V17.0632H28.7606Z",
    fill: "#F79E1B",
    style: {
      fill: "#F79E1B",
      fill: "color(display-p3 0.9686 0.6196 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.4ff4c59fe1866cfe18a0d997cfd022e9.svg";
export { ForwardRef as ReactComponent };